
import './App.css';
// import {  Navbar, Header2,Partners2,Products, Rds2, SectionBlog, Projects2, AboutUs, Team,Hiring1, Footer2} from './components'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {NavApp, Home, Careers, Blog, PageBlog, PageBlog2, PageBlog3, PageBlog4, PageBlog5, PageBlog6, BrandAssets, NotFound} from './components';
 import ScrollToTop from './components/ScrollToTop';

function App() {

  return (
    
     <div>
        <BrowserRouter>
      <ScrollToTop />
      <NavApp/>
      <Routes>
         <Route index element={<Home/>} />
         <Route path='/careers' element={<Careers/>} /> 
         <Route path='/brand-assets' element={<BrandAssets/>} /> 
         <Route path="/blog" element={<Blog />} />
          <Route path='/blog/commoditizing-zero-knowledge-proofs' element={<PageBlog/>} />
         <Route path='/blog/ponos-technology-s-hw-accelerated-plonky2-goldibear' element={<PageBlog2/>} />
         <Route path='/blog/cryptocpu-validation-proving-made-fast-affordable-and-seamless' element={<PageBlog3/>} />
          <Route path='/blog/scaling-stablecoins-with-confidentiality' element={<PageBlog4/>} />
          <Route path='/blog/tech-deep-dive' element={<PageBlog5/>} />
          <Route path='/blog/cryptocpu-making-zero-knowledge-proofs-fast-cost-disruptive-and-scalable' element={<PageBlog6/>} />
         <Route path='*' element={<NotFound/>} /> 
      </Routes>
      </BrowserRouter>

       {/* <Navbar/> 
       <Header2/>
       <Partners2/>
       <Products/>
       <Rds2/>
       <SectionBlog/>
       <Projects2/>
       <AboutUs/>
       <Team/>
       <Hiring1/>
      <Footer2/> */}
  
   </div>
  
  
  );
}

export default App;
